// extracted by mini-css-extract-plugin
module.exports = {"column":"_base-column-496e8148962d59df846fc18537ddf14e","padding":"_base-column-46f806338705c798844a6662ef0cac2f"};